import { ActionTree } from 'vuex'
import scriptTemplatesApiService from '@/services/scriptTemplates'
import { ScriptTemplatesMutationTypes } from './mutations'

import type { RootState } from '../../state'
import type { ScriptTemplatesState } from './state'

export enum ScriptTemplatesAction {
  getScriptTemplates = 'getScriptTemplates',
  useScriptTemplate = 'useScriptTemplate',
}


export const actions: ActionTree<ScriptTemplatesState, RootState> = {
  async [ScriptTemplatesAction.getScriptTemplates](context) {
    const response = await scriptTemplatesApiService.getScriptTemplates()

    context.commit(ScriptTemplatesMutationTypes.setScriptTemplates, response.data)

    return response
  },

  async [ScriptTemplatesAction.useScriptTemplate](context, id: string) {
    const response = await scriptTemplatesApiService.useScriptTemplate(id)
    return response.data
  },
}
